import {maybeUpdateTimezones, pushAnalyticsData} from "./utils";

import './cl2-products-view.scss'

( function( $ ) {
	'use strict';

	$(document).ready(function() {

		if ( location.href.indexOf( 'member-upg=1' ) !== - 1 ) {
			/**
			 * if running membership upgrade test (done for Elite on 7/22/2022)
			 * fetch membership status on hover
			 */
			$( '.grid-col > .card' ).on( 'mouseenter', e => {
				const $target = $( e.target );
				const $card = $target.closest( '.card' );
				const $addToCart = $card.children( '.add-to-cart-container' ).first();

				if ( $addToCart.length && !$addToCart.prop( 'upsell' ) && !$addToCart.prop( 'is-checking-upsell' ) ) {
					$addToCart.trigger( 'UPDATE_ADD_TO_CART_BUTTON', {
						productCode: $addToCart.data( 'product-code' )
					} );
				}
			} );
		}

		/**
		 * Insert a general template for modal (if it is not there yet).
		 *
		 * This is needed to support a general-purpose modal
		 * @note we exclude map modals
		 */
		if ( !$( 'body > .modal:not(.modal--map)' ).length ) {
			$( 'body' ).append(
				'<div class="modal" tabIndex="-1" role="dialog">' +
					'<div class="modal-dialog modal-dialog-centered" role="document">' +
						'<div class="modal-content">' +
							'<div class="modal-header">' +
								'<h5 class="modal-title"></h5>' +
								'<button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Close">' +
									'<span aria-hidden="true">&times;</span>' +
								'</button>' +
							'</div>' +
						'<div class="modal-body"></div>' +
					'</div>' +
				'</div>'
			);
		}

		/**
		 * Pop up modals when a link with rel="modal" is clicked
		 */
		$('body').on( 'click', '[rel="modal"]', e => {

			if ( e?.originalEvent?.defaultPrevented ){
				return;
			}

			const $target = $( e.target );
			const $card = $target.closest('.card');

			// console.log( $card.attr( 'data-product-status' ) );

			if ( !$card.length || !['sellable_done', 'enrollable_done'].includes( $card.attr( 'data-product-status' ) ) ) {
				//the regular QuickView modal will be displayed by the global modal logic in cds-modal.js
				return;
			}

			const $addToCart = $card.find( '.add-to-cart-container' ).first();

			if ( !$addToCart.length ) {
				return;
			}

			const productStatus = $card.attr( 'data-product-status' );

			const isProductAction = $target.is( '.add-to-cart-container' ) || $target.is( '.add-to-cart' ) || $target.is( '.product-action-button' );

			// console.log(isProductAction);

			/**
			 * found addToCard button, so this is a card and we need to support Quick View modal
			 */
			if ( $target === $addToCart && $addToCart.is( 'product-action-button' ) ) {
				const ctrl = $addToCart[ 0 ].shadowRoot.querySelector( '.ctrl' );
				// console.log(ctrl, e);
				e.preventDefault();
				if ( ctrl.tagName === 'A' ) {
					window.location.href = ctrl.getAttribute( 'href' );
				}
				return false;
			} else if ( ( $target.is( '.card' ) || $target.is( '.mode-cta' ) ) && ['sellable_done', 'enrollable_done'].includes( productStatus ) ) {
				e.preventDefault();
				const href = $card.find( ( ( 'sellable_done' === productStatus )
													? '.checkout'
													: '.dashboard' ) + ' .cds-button' ).first().attr( 'href' );
				window.location.href = href
											  ? href
											  : $addToCart[ 0 ].shadowRoot.querySelector( '.ctrl' ).getAttribute( 'href' );
				return false;
			} else if ( !$addToCart.is( '.is-popup-handle' ) && !$addToCart.children( '.is-unknown-state' ).length ) {
				/**
				 * do not call up the modal if this click is processed already
				 */
				if ( $target.closest( '.add-to-cart-container' ).length ) {
					if ( $target !== $addToCart && $target.find( 'button' ).length ) {
						$target.find( 'button' ).click();
					} else if ( $target.find( 'a[href]' ).length ) {
						window.location.href = $target.find( 'a[href]' ).attr( 'href' );
					}
					e.preventDefault();
					return false;
				}
			} //end of

			e.preventDefault();
			return false;
		});

		$('body').on('click', '.card .toggle-view-more[aria-expanded="false"]', e => {
			//alert('you clicked on view-more');

			const viewMoreContainer = $(e.target).closest('.card').find('.view-more-container');
			if ( $(e.target).hasClass('collapsed') ){
				$(e.target).closest('.toggle-view-more').removeClass('collapsed');
				if (viewMoreContainer && viewMoreContainer.hasClass('collapse') ) {
					viewMoreContainer.toggleClass('collapse');
				}
			} else {
				$(e.target).closest('.toggle-view-more').addClass('collapsed');
				if (viewMoreContainer && !viewMoreContainer.hasClass('collapse') ) {
					viewMoreContainer.toggleClass('collapse');
				}
			}

			const $addToCart = $(e.target).closest('.card').find('.add-to-cart-container').first();
			const productCode = $addToCart.length ? $addToCart.data('product-code') || $addToCart.attr('product-code'): null;
			if ( productCode ){
				pushAnalyticsData( productCode, 'view_item' );
			}
		});

		$('body').on('change', '.pricing-container .switch input', function(e){
			const $container = $(e.target).closest('.pricing-container');
			const $inner = $container.find('.pricing-inner:visible').first();
			let $invisible = $container.find('.pricing-inner:not(:visible)').first();

			if ( !$invisible.length ){
				$invisible = $($inner.next().contents().find( '.pricing-inner' ).first()[0].outerHTML);
				$inner.after( $invisible );
			}

			$inner.hide();
			$invisible.show();

			//update CTAs on the parent card
			const productNew = $invisible.data('product-code');
			const payOptNew  = $invisible.find('.payment-term').data('payment-option-id');

			$container.closest( '.card' ).find( '.add-to-cart-container' ).each( ( i, el ) => {
				//We should check if product is available or in the cart already.
				//note we set "alt-*" to preserve the original product code, because it can be used for indexing DOM elements.

				$( el ).data( 'alt-payment-option-id', payOptNew ).data( 'alt-product-code', productNew );

				$(window).trigger( 'ColibriEvent:INIT_ADD_TO_CART', $( el ) );
			} );

		});

		$('body').on('click', '.modal-body .payment-options button', function(e){

			// function readCookie( name ) {
			// 	const nameEQ = name + '=';
			// 	const ca = document.cookie.split( ';' );
			// 	for ( let i = 0; i < ca.length; i ++ ) {
			// 		let c = ca[ i ];
			// 		while ( c.charAt( 0 ) === ' ' ) {
			// 			c = c.substring( 1, c.length );
			// 		}
			// 		if ( c.indexOf( nameEQ ) === 0 ) {
			// 			return c.substring( nameEQ.length, c.length );
			// 		}
			// 	}
			// 	return null;
			// }

			function setCookie(name,value,days) {
				var expires = "";
				if (days) {
					var date = new Date();
					date.setTime(date.getTime() + (days*24*60*60*1000));
					expires = "; expires=" + date.toUTCString();
				}

				var temp = location.host;
				temp = temp ? temp.split('.'): '';
				temp = temp ? temp.reverse(): '';
				temp = temp ? '.' + temp[1] + '.' + temp[0] : '';

				const domain = temp ? '; domain=' + temp: '';

				document.cookie = name + "=" + (value || "")  + expires + domain + "; path=/";
			}

			function deleteCookie(name){
				document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
			}

			const $button  = $(e.target);
			const prodCode = $button.data('product-code');
			const planId   = $button.data('payment-option-id');
			const partnerId = $button.data( 'partnership-id' );
			const partnerGroupItemId = $button.data( 'partnership-group-item-id' ) ?? 0;

			if ( partnerId ) {
				setCookie( 'STYXKEY-partnershipid', partnerId, 1 );
			} else {
				deleteCookie( 'STYXKEY-partnershipid' );
			}

			let url = window.colibri.studentApi + '/cart/items.json?searchResultId=' + prodCode;

			//we would get this from product status check
			// url += enrollmentId
			// 	   ? '&enrollmentId=' + enrollmentId
			// 	   : '';

			url += planId
				   ? '&paymentOptionId=' + planId
				   : '';

			url += partnerGroupItemId
				   ? '&PartnershipGroupItemId=' + partnerGroupItemId
				   : '';

			url += '&addedFrom=PaymentPlanModal';

			$.ajax( {
				url,
				type: 'GET',
				cache: false,
				timeout: 30000,
				async: true,
				crossDomain: true,
				xhrFields: {
					withCredentials: true,
				},
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				processData: false,
				error: function() {
					return true;
				},
				success: function( msg ) {
					window.location.href = window.colibri.cartUrl;
				}
			} );
		} );

		// Align buttons on packages when Affirm text is loaded
		function addAffirmClass() {
			const affirmBlock = document.querySelector('.affirm-as-low-as');

			if (!affirmBlock) {
				return;
			}

			const priceElements = document.querySelectorAll('.card .price');

			function updatePriceElements() {
				priceElements.forEach(function (element) {
					element.classList.add('has-affirm');
				});
			}

			// Check if Affirm block is updated based on location
			const mutationCallback = function (mutationsList) {
				for (const mutation of mutationsList) {
					if (mutation.type === 'childList' && mutation.target.classList.contains('affirm-as-low-as')) {
						updatePriceElements();
					}
				}
			};

			const observer = new MutationObserver(mutationCallback);
			const observerConfig = { childList: true, subtree: true };

			observer.observe(affirmBlock, observerConfig);
		}

		addAffirmClass();

	});

} )( jQuery );
